// utils/common/installId.ts

// Persistent per-install ID (not tied to key). Stored in Cookie + localStorage for resilience.

import Cookies from "js-cookie";

const INSTALL_ID_KEY = "install_id";

const isBrowser = () => typeof window !== "undefined";
const normalize = (s: string) => (s || "").trim().toLowerCase();

function randomId(len = 32) {
  const alphabet = "abcdefghijklmnopqrstuvwxyz0123456789";
  let out = "";
  const cryptoOk = typeof crypto !== "undefined" && !!crypto.getRandomValues;
  if (cryptoOk) {
    const bytes = new Uint8Array(len);
    crypto.getRandomValues(bytes);
    for (let i = 0; i < len; i++) out += alphabet[bytes[i] % alphabet.length];
    return out;
  }
  for (let i = 0; i < len; i++) out += alphabet[Math.floor(Math.random() * alphabet.length)];
  return out;
}

function setInstallIdCookie(id: string) {
  if (!isBrowser()) return;
  const secure = window.location.protocol === "https:";
  Cookies.set(INSTALL_ID_KEY, id, {
    expires: 365 * 2, // 2 years
    sameSite: "Strict",
    secure,
    path: "/",
  });
}

export async function getInstallIdAsync(): Promise<string> {
  if (!isBrowser()) return "server";
  let id = (localStorage.getItem(INSTALL_ID_KEY) || Cookies.get(INSTALL_ID_KEY) || "").trim();
  if (!id) {
    id = randomId(32);
    const norm = normalize(id);
    localStorage.setItem(INSTALL_ID_KEY, norm);
    setInstallIdCookie(norm);
    return norm;
  }
  const norm = normalize(id);
  localStorage.setItem(INSTALL_ID_KEY, norm);
  setInstallIdCookie(norm);
  return norm;
}

export function getInstallIdSync(): string {
  if (!isBrowser()) return "server";
  const id = (localStorage.getItem(INSTALL_ID_KEY) || Cookies.get(INSTALL_ID_KEY) || "").trim();
  return id ? normalize(id) : "unknown";
}
